import { Composition } from "@core/models/composition.model";
import { CompositionVersion } from "@core/models/composition-version.model";
import { CompositionsInfo } from "@core/models/compositions-info.model";
import { FundWithRelated } from "@core/models/fund-with-related.model";
import { RiskProfile } from "@core/models/risk-profile.model";
import { createAction, props } from "@ngrx/store";

export const LOAD_COMPOSITION_MODEL_LIST = createAction(
  "[Composition Model] Load Composition Model List",
  props<{ searchTerm?: string }>()
);

export const SET_COMPOSITION_MODEL_LIST = createAction(
  "[Composition Model] Set Composition Model List",
  props<{ compositionModelList: Array<Composition> }>()
);

export const SET_COMPOSITION_MODEL_LOADING_STATUS = createAction(
  "[Composition Model] Set Composition Model Loading Status",
  props<{ loading: boolean }>()
);

export const SAVE_COMPOSITION_MODEL = createAction(
  "[Composition Model] Save Composition Model",
  props<{ compositionModel: Partial<Composition>; id: string | undefined }>()
);

export const SAVE_COMPOSITION_MODEL_VERSION = createAction(
  "[Composition Model] Save Composition Model Version",
  props<{
    compositionModelVersion: Partial<CompositionVersion>;
    id: string | undefined;
  }>()
);

export const LOAD_COMPOSITION_MODEL_LIST_INFO = createAction(
  "[Composition Model] Load Composition Model List Info"
);

export const SET_COMPOSITION_MODEL_LIST_INFO = createAction(
  "[Composition Model] Set Composition Model List Info",
  props<{ compositionListInfo: CompositionsInfo }>()
);

export const LOAD_PRODUCT_FUND_LIST = createAction(
  "[Composition Model] Load Product Fund List",
  props<{ id: string }>()
);

export const SET_PRODUCT_FUND_LIST = createAction(
  "[Composition Model] Set Product Fund List",
  props<{ productFundList: Array<FundWithRelated> }>()
);

export const LOAD_RISK_PROFILES_LIST = createAction(
  "[Composition Model] Load Risk Profiles List"
);

export const SET_RISK_PROFILES_LIST = createAction(
  "[Composition Model] Set Risk Profiles List",
  props<{ riskProfilesList: Array<RiskProfile> }>()
);

export const CHECK_RISK_PROFILE = createAction(
  "[Composition Model] Check Risk Profile",
  props<{ riskProfileId: string; productId: string }>()
);

export const SET_RISK_PROFILE_EXISTS_STATUS = createAction(
  "[Composition Model] Set Risk Profile Exists",
  props<{ riskProfileExists: boolean }>()
);

export const LOAD_COMPOSITION_MODEL = createAction(
  "[Composition Model] Load Composition Model",
  props<{ id: string }>()
);

export const SET_COMPOSITION_MODEL = createAction(
  "[Composition Model] Set Composition Model",
  props<{ compositionModel: Composition | null }>()
);
